// internal
import { axios, storage, def, handleError } from './internal';

function MfaDisable(code, useBackupCode, onSuccess) {
    axios
        .post('/api/mfa_disable', { code, useBackupCode })
        .then((res) => {
            onSuccess?.(res.data.data);
        })
        .catch((err) => {
            const { status, data } = err.response || {};
            switch (status) {
                case def.StatusCodes.BAD_REQUEST: // 400
                    switch (data?.code) {
                        case def.ErrorCode.MFA_NOT_ENABLED:
                            storage.transience.setState('internal.error', 'Two-factor authentication is not enabled.');
                            break;
                        default:
                            handleError(err);
                            break;
                    }
                    break;
                case def.StatusCodes.UNAUTHORIZED: // 401
                    switch (data?.code) {
                        case def.ErrorCode.MFA_INVALID_CODE:
                            storage.transience.setState('internal.error', 'Invalid code. Please try again.');
                            break;
                        default:
                            handleError(err);
                            break;
                    }
                    break;
                default:
                    handleError(err);
                    break;
            }
        });
}

export { MfaDisable };
